// import toast from 'react-hot-toast';

// const openNotification = (type, description) => {
//   switch(type){
//     case 'info':
//       toast(description);
//       break
//     case 'success':
//       toast.success(description);
//       break
//     case 'error':
//       toast.error(description);
//     default:
//       break
//   }
// };
// export default openNotification;

// utils/openNotification.js
import toast from 'react-hot-toast';

// Lưu trạng thái hiển thị toast
const showingErrors = {};

const openNotification = (type, description) => {
  // Nếu đang hiển thị lỗi này thì bỏ qua
  if (showingErrors[description]) return;

  showingErrors[description] = true;

  switch (type) {
    case 'info':
      toast(description);
      break;
    case 'success':
      toast.success(description);
      break;
    case 'error':
      toast.error(description);
      break;
    default:
      break;
  }

  // Sau 3 giây reset cờ để có thể hiển thị lại
  setTimeout(() => {
    showingErrors[description] = false;
  }, 3000);
};

export default openNotification;
